import React from 'react'
import Layout from '../common/Layout'
import { Link } from 'react-router-dom'

const PageNotFound = () => {
    return (
        <>
            {/* fix style */}
            <div style={{ margin: 0, padding: 0, backgroundColor: '#ffffffff', color: '#F3F4F6', fontFamily: 'Inter sans-serif, Arial', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', textAlign: 'center', boxSizing: 'border-box' }}>
                <div style={{ padding: '2rem', maxWidth: '600px', width: '100%' }}>

                    <div style={{ marginBottom: '2.5rem', display: 'flex', justifyContent: 'center' }}>
                        <img src="img/logo-light.png" alt="Logo" style={{ maxWidth: '180px', height: 'auto' }} />
                    </div>

                    <div style={{ fontSize: '7rem', fontWeight: '800', lineHeight: '1', marginBottom: '0.5rem', color: '#6366F1', letterSpacing: '-2px' }}>
                        404
                    </div>

                    <h1 style={{ fontSize: '2rem', fontWeight: '600', margin: '0 0 1rem 0' }}>Oops! Page Not Found</h1>

                    <p style={{ color: '#9CA3AF', fontSize: '1.125rem', margin: '0 auto 2.5rem', lineHeight: '1.6', maxWidth: '450px' }}>
                        It looks like the product or category you are searching for doesn't exist, has been removed, or is temporarily unavailable.
                    </p>

                    <a href="/" style={{ display: 'inline-block', backgroundColor: '#6366F1', color: '#ffffff', textDecoration: 'none', padding: '0.875rem 2.5rem', borderRadius: '50px', fontWeight: '500', fontSize: '1rem', boxShadow: '0 4px 14px 0 rgba(99, 102, 241, 0.39)' }}>
                        Go Back
                    </a>

                </div>
            </div >
        </>
    )
}

export default PageNotFound
